export default __webpack_public_path__ + "static/einmalig-hybrid-international-9e5afdf4d1e4206914d375b8a9348128.jpg";